export var otpValidityTime = {
    min: 9,
    sec: 59,
};
export var loginScreenState;
(function (loginScreenState) {
    loginScreenState["LOGIN"] = "LOGIN";
    loginScreenState["PASSWORD"] = "PASSWORD";
    loginScreenState["OTP"] = "OTP";
    loginScreenState["CHOOSE_ACCOUNT"] = "CHOOSE_ACCOUNT";
    loginScreenState["FORGOT_LOGIN_ID"] = "FORGOT_LOGIN_ID";
    loginScreenState["FORGOT_PASSWORD"] = "FORGOT_PASSWORD";
    loginScreenState["UNBLOCK_USER_TYPE"] = "UNBLOCK_USER_TYPE";
    loginScreenState["UNBLOCK_USER"] = "UNBLOCK_USER";
    loginScreenState["DEFAULT"] = "DEFAULT";
    loginScreenState["GUEST_LOGIN"] = "GUEST_LOGIN";
    loginScreenState["GUEST_LOGIN_MPIN"] = "GUEST_LOGIN_MPIN";
    loginScreenState["GUEST_LOGIN_TRIAL"] = "GUEST_LOGIN_TRIAL";
    loginScreenState["GUEST_REGISTER"] = "GUEST_REGISTER";
    loginScreenState["GUEST_VERIFY_MOBILE_OTP"] = "GUEST_VERIFY_MOBILE_OTP";
    loginScreenState["GUEST_VERIFY_EMAIL_OTP"] = "GUEST_VERIFY_EMAIL_OTP";
    loginScreenState["GUEST_SET_MPIN"] = "GUEST_SET_MPIN";
    loginScreenState["GUEST_EMAIL"] = "GUEST_EMAIL";
    loginScreenState["GUEST_FORGOT_MPIN"] = "GUEST_FORGOT_MPIN";
    loginScreenState["LOGIN_HELP"] = "LOGIN_HELP";
    loginScreenState["MOBILE_APP"] = "MOBILE_APP";
    loginScreenState["EXTERNAL_OTP"] = "EXTERNAL_OTP";
})(loginScreenState || (loginScreenState = {}));
export var forgotLoginIdState;
(function (forgotLoginIdState) {
    forgotLoginIdState["FORGOT_LOGIN_ID"] = "FORGOT_LOGIN_ID";
    forgotLoginIdState["SUCCESS_STATE"] = "SUCCESS_STATE";
    forgotLoginIdState["FAILIURE_STATE"] = "FAILIURE_STATE";
})(forgotLoginIdState || (forgotLoginIdState = {}));
export var forgotPasswordState;
(function (forgotPasswordState) {
    forgotPasswordState["NEW_PASSWORD"] = "NEW_PASSWORD";
    forgotPasswordState["FORGOT_PASSWORD"] = "FORGOT_PASSWORD";
    forgotPasswordState["SUCCESS_STATE"] = "SUCCESS_STATE";
    forgotPasswordState["SECURE_LOGIN"] = "SECURE_LOGIN";
    forgotPasswordState["OTP"] = "OTP";
})(forgotPasswordState || (forgotPasswordState = {}));
export var unblockUserState;
(function (unblockUserState) {
    unblockUserState["UNBLOCK_USER"] = "UNBLOCK_USER";
    unblockUserState["SUCCESS_STATE"] = "SUCCESS_STATE";
    unblockUserState["UNBLOCK_USER_TYPE"] = "UNBLOCK_USER_TYPE";
})(unblockUserState || (unblockUserState = {}));
export var externalTOTP;
(function (externalTOTP) {
    externalTOTP["DISABLED_TOTP"] = "DISABLED_TOTP";
    externalTOTP["FAILED_DISABLE_TOTP"] = "FAILED_DISABLE_TOTP";
    externalTOTP["VERIFY_OTP_TOTP"] = "VERIFY_OTP_TOTP";
    externalTOTP["SUCESSFULLY_TOTP"] = "SUCESSFULLY_TOTP";
    externalTOTP["FAILED_TOTP"] = "FAILED_TOTP";
    externalTOTP["FAILED_SECRET_KEY"] = "FAILED_SECRET_KEY";
    externalTOTP["CHANGE_AUTHENTICATE_TOTP"] = "CHANGE_AUTHENTICATE_TOTP";
    externalTOTP["EXTERNAL_SCAN_TOTP"] = "EXTERNAL_SCAN_TOTP";
    externalTOTP["SUCESSFULLY_EXTERNAL_TOTP"] = "SUCESSFULLY_EXTERNAL_TOTP";
    externalTOTP["SWITCH_EXTERNAL_TOTP"] = "SWITCH_EXTERNAL_TOTP";
})(externalTOTP || (externalTOTP = {}));
export var changePassword;
(function (changePassword) {
    changePassword["CHANGE_PASSWORD"] = "CHANGE_PASSWORD";
    changePassword["PASSWORD_CHANGED"] = "PASSWORD_CHANGED";
    changePassword["PASSWORD_FAILED"] = "PASSWORD_FAILED";
})(changePassword || (changePassword = {}));
export var handleNavigateUrl = function (baseUrl, redirectQuery) {
    if (redirectQuery) {
        return "".concat(baseUrl, "?redirectUrl=").concat(encodeURIComponent(redirectQuery));
    }
    else {
        return baseUrl;
    }
};
export var EAccountType;
(function (EAccountType) {
    EAccountType["CO"] = "CO";
    EAccountType["EQ"] = "EQ";
    EAccountType["COMEQ"] = "COMEQ";
})(EAccountType || (EAccountType = {}));
export var EClientAcntType;
(function (EClientAcntType) {
    EClientAcntType["CO"] = "CO";
    EClientAcntType["EQ"] = "EQ";
    EClientAcntType["COMEQ"] = "COMEQ";
    EClientAcntType["REG"] = "REG";
    EClientAcntType["OTC"] = "OTC";
})(EClientAcntType || (EClientAcntType = {}));
